import { StandaloneProdukt } from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { GlobalActions, UpdateLoadedVorvertraege } from '@ps20-frontend/shop-integration-redux';
import { StandaloneVertragsuebersicht } from '@ps20/bff-models';
import cloneDeep from 'lodash/cloneDeep';
import { DashboardActions } from '../dashboard.actions';
import { updateVertraege } from './fremdVertrag.reducer';

export const standaloneProduktReducer = function (
  sectionState: Array<StandaloneProdukt> = null,
  action: AnyAction,
): Array<StandaloneProdukt> {
  switch (action.type) {
    case GlobalActions.UPDATE_VORVERTRAEGE: {
      const actionPayload: UpdateLoadedVorvertraege = action.payload;
      return actionPayload.standaloneVorvertraege;
    }
    case DashboardActions.UPDATE_STANDARD_STANDALONEPRODUKTE: {
      const payload: Array<StandaloneVertragsuebersicht> = action.payload;
      const standaloneProdukte: Array<StandaloneProdukt> = cloneDeep(sectionState);
      return updateVertraege(payload, standaloneProdukte) as Array<StandaloneProdukt>;
    }
    default:
      return sectionState;
  }
};
